<div class="cookie-consent-container d-flex align-items-center text-center scroll-sm" *ngIf="!cookieAccepted">
    <div class="cookie-consent-wrapper flex-column">
        <img src="../../../../assets/img/cookie.svg" alt="cookie image">

        <!-- Main consent view -->
        <div class="message my-3" *ngIf="!showCustomize">
            <div class="english-text" *ngIf="currentLanguage === 'EN'">
                <h4>Cookie Settings</h4>
                <p>We use cookies to improve your experience on our website. Some cookies are essential for the site to function, while others help us analyze usage and provide personalized content.</p>
                <p><strong>Required Cookies:</strong> Necessary for age verification (18+) and basic site functionality.</p>
                <p><strong>Analytical Cookies:</strong> Help us understand how visitors use our website (Google Analytics, Microsoft Clarity).</p>
                <p><strong>Marketing Cookies:</strong> Used to show you relevant advertisements (Google AdSense).</p>
                <p>You can customize your preferences or accept/reject all optional cookies. You can change your settings anytime in "My Profile".</p>
            </div>
            <div class="german-text" *ngIf="currentLanguage === 'DE'">
                <h4>Cookie-Einstellungen</h4>
                <p>Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website zu verbessern. Einige Cookies sind für die Funktion der Website unerlässlich, während andere uns helfen, die Nutzung zu analysieren und personalisierte Inhalte bereitzustellen.</p>
                <p><strong>Erforderliche Cookies:</strong> Notwendig für die Altersverifikation (18+) und grundlegende Website-Funktionen.</p>
                <p><strong>Analytische Cookies:</strong> Helfen uns zu verstehen, wie Besucher unsere Website nutzen (Google Analytics, Microsoft Clarity).</p>
                <p><strong>Marketing-Cookies:</strong> Werden verwendet, um Ihnen relevante Werbung anzuzeigen (Google AdSense).</p>
                <p>Sie können Ihre Einstellungen anpassen oder alle optionalen Cookies akzeptieren/ablehnen. Sie können Ihre Einstellungen jederzeit unter "Mein Profil" ändern.</p>
            </div>
        </div>

        <!-- Customize view -->
        <div class="message my-3 text-left" *ngIf="showCustomize">
            <div class="english-text" *ngIf="currentLanguage === 'EN'">
                <h4>Customize Cookie Preferences</h4>
                <div class="cookie-option mb-2">
                    <label class="d-flex align-items-center">
                        <input type="checkbox" [checked]="requiredCookies" disabled class="mr-2">
                        <strong>Required Cookies (Always Active)</strong>
                    </label>
                    <small class="ml-4">Essential for site functionality and age verification.</small>
                </div>
                <div class="cookie-option mb-2">
                    <label class="d-flex align-items-center">
                        <input type="checkbox" [(ngModel)]="analyticalCookies" class="mr-2">
                        <strong>Analytical Cookies</strong>
                    </label>
                    <small class="ml-4">Help us improve our website by analyzing visitor behavior (Google Analytics, Microsoft Clarity).</small>
                </div>
                <div class="cookie-option mb-2">
                    <label class="d-flex align-items-center">
                        <input type="checkbox" [(ngModel)]="socialCookies" class="mr-2">
                        <strong>Social Media Cookies</strong>
                    </label>
                    <small class="ml-4">Enable social sharing features.</small>
                </div>
                <div class="cookie-option mb-2">
                    <label class="d-flex align-items-center">
                        <input type="checkbox" [(ngModel)]="marketingCookies" class="mr-2">
                        <strong>Marketing Cookies</strong>
                    </label>
                    <small class="ml-4">Show you personalized advertisements (Google AdSense).</small>
                </div>
            </div>
            <div class="german-text" *ngIf="currentLanguage === 'DE'">
                <h4>Cookie-Einstellungen anpassen</h4>
                <div class="cookie-option mb-2">
                    <label class="d-flex align-items-center">
                        <input type="checkbox" [checked]="requiredCookies" disabled class="mr-2">
                        <strong>Erforderliche Cookies (Immer aktiv)</strong>
                    </label>
                    <small class="ml-4">Unerlässlich für die Website-Funktionalität und Altersverifikation.</small>
                </div>
                <div class="cookie-option mb-2">
                    <label class="d-flex align-items-center">
                        <input type="checkbox" [(ngModel)]="analyticalCookies" class="mr-2">
                        <strong>Analytische Cookies</strong>
                    </label>
                    <small class="ml-4">Helfen uns, unsere Website zu verbessern, indem wir das Besucherverhalten analysieren (Google Analytics, Microsoft Clarity).</small>
                </div>
                <div class="cookie-option mb-2">
                    <label class="d-flex align-items-center">
                        <input type="checkbox" [(ngModel)]="socialCookies" class="mr-2">
                        <strong>Social-Media-Cookies</strong>
                    </label>
                    <small class="ml-4">Aktivieren Social-Sharing-Funktionen.</small>
                </div>
                <div class="cookie-option mb-2">
                    <label class="d-flex align-items-center">
                        <input type="checkbox" [(ngModel)]="marketingCookies" class="mr-2">
                        <strong>Marketing-Cookies</strong>
                    </label>
                    <small class="ml-4">Zeigen Ihnen personalisierte Werbung (Google AdSense).</small>
                </div>
            </div>
        </div>

        <!-- Buttons -->
        <div class="buttons" *ngIf="!showCustomize">
            <button class="btn tr-btn-primary btn-accept mr-2" (click)="acceptAllCookies()">
                {{ currentLanguage === 'EN' ? 'Accept All' : 'Alle akzeptieren' }}
            </button>
            <button class="btn tr-btn-secondary btn-reject mr-2" (click)="rejectAllCookies()">
                {{ currentLanguage === 'EN' ? 'Reject Optional' : 'Optional ablehnen' }}
            </button>
            <button class="btn tr-btn-secondary btn-customize" (click)="showCustomizeOptions()">
                {{ currentLanguage === 'EN' ? 'Customize' : 'Anpassen' }}
            </button>
        </div>

        <div class="buttons" *ngIf="showCustomize">
            <button class="btn tr-btn-primary btn-accept mr-2" (click)="saveCustomPreferences()">
                {{ currentLanguage === 'EN' ? 'Save Preferences' : 'Einstellungen speichern' }}
            </button>
            <button class="btn tr-btn-secondary btn-back" (click)="showCustomize = false">
                {{ currentLanguage === 'EN' ? 'Back' : 'Zurück' }}
            </button>
        </div>
    </div>
</div>
<div class="backdrop" *ngIf="!cookieAccepted"></div>